import { render, staticRenderFns } from "./EditProfileModal.vue?vue&type=template&id=13654324&scoped=true"
import script from "./EditProfileModal.vue?vue&type=script&lang=js"
export * from "./EditProfileModal.vue?vue&type=script&lang=js"
import style0 from "./EditProfileModal.vue?vue&type=style&index=0&id=13654324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13654324",
  null
  
)

export default component.exports